import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { IconMagnify } from '@sfx/icons';

var prefix = "sfx-react-ui";

var SearchInput = /*#__PURE__*/function (_Component) {
  _inherits(SearchInput, _Component);

  var _super = _createSuper(SearchInput);

  function SearchInput() {
    var _this;

    _classCallCheck(this, SearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "searchInputRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (element) {
      _this.searchInputRef = element;
    });

    _defineProperty(_assertThisInitialized(_this), "stopEnterTab", function (e) {
      var keyCode = e.keyCode || e.which;

      if (keyCode === 9) {
        e.preventDefault();
      }

      if (keyCode === 13) {
        _this.onSearchClick();
      }

      e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchClick", function () {
      var onSearchClick = _this.props.onSearchClick;
      onSearchClick && onSearchClick(_this.searchInputRef.value);
    });

    return _this;
  }

  _createClass(SearchInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.searchInputRef && this.searchInputRef.focus();
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          onSearchClick = _this$props.onSearchClick,
          restProps = _objectWithoutProperties(_this$props, ["placeholder", "onSearchClick"]);

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-SearchInput")
      }, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || '',
        ref: this.setInputRef,
        onKeyDown: this.stopEnterTab
      }, restProps)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-iconSearch"),
        onClick: this.onSearchClick
      }, /*#__PURE__*/React.createElement(IconMagnify, {
        size: "18"
      })));
    }
  }]);

  return SearchInput;
}(Component);
/**
 * @deprecated
 * Recommend to use SearchInput
 */


var SearchInput2 = SearchInput;
export { SearchInput2 };
export default SearchInput;